import type { NavigateFunction } from 'react-router-dom';

/**
 * Ouverture d'un cas d'usage, quel que soit l'écran d'où on le clique.
 *
 * Les cas d'usage sont affichés par plusieurs pages, qui dupliquaient chacune
 * leur propre logique d'ouverture. Elle est centralisée ici pour qu'un cas
 * d'usage migré s'ouvre de la même façon partout.
 */
export interface OuvrableUseCase {
  id: number;
  link?: string;
  mode?: 'lien' | 'natif';
}

/**
 * Renvoie false si le cas d'usage n'est pas ouvrable, pour que l'appelant
 * puisse afficher son propre message.
 */
export function ouvrirUseCase(
  useCase: OuvrableUseCase,
  navigate: NavigateFunction,
): boolean {
  // Cas d'usage migré : l'assistant s'ouvre dans la plateforme, sans onglet
  // externe ni compte tiers.
  if (useCase.mode === 'natif') {
    navigate(`/workspace/assistant/${useCase.id}`);
    return true;
  }

  if (!useCase.link) {
    return false;
  }

  if (useCase.link.startsWith('http://') || useCase.link.startsWith('https://')) {
    window.open(useCase.link, '_blank', 'noopener,noreferrer');
  } else {
    window.open(useCase.link, '_blank');
  }
  return true;
}
